var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "wifi_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#wifi_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.85 14.825a.66.66 0 0 1-.225-.513q0-.312.225-.487a9 9 0 0 1 2.813-1.688A9.4 9.4 0 0 1 12 11.55q1.775 0 3.338.6 1.562.6 2.812 1.675.225.175.225.487a.73.73 0 0 1-.225.538q-.2.2-.5.2a.83.83 0 0 1-.525-.175 8.3 8.3 0 0 0-2.35-1.375A7.7 7.7 0 0 0 12 13q-1.474 0-2.775.5a8.3 8.3 0 0 0-2.35 1.375.72.72 0 0 1-.525.187.68.68 0 0 1-.5-.237M1.6 10.6a.72.72 0 0 1-.225-.525q0-.3.225-.5a16 16 0 0 1 4.713-2.95Q8.95 5.55 12 5.55t5.688 1.075a16 16 0 0 1 4.712 2.95q.225.2.225.5a.72.72 0 0 1-.225.525q-.2.2-.5.2a.77.77 0 0 1-.525-.2A14 14 0 0 0 17.1 7.95Q14.7 7 12 7t-5.1.95a14 14 0 0 0-4.275 2.65.77.77 0 0 1-.525.2.68.68 0 0 1-.5-.2M12 20.2q-.6 0-1.012-.412a1.38 1.38 0 0 1-.413-1.013q0-.6.413-1.012A1.37 1.37 0 0 1 12 17.35q.6 0 1.013.413.412.412.412 1.012t-.412 1.013A1.38 1.38 0 0 1 12 20.2"
  }))));
};
export default SvgWifi;